import { createContext, useState, FC, useCallback } from 'react'

import { INVESTMENT_FORM_DATA, CURRENT_WEBSITE_FORM_DATA, NEW_WEBSITE_FORM_DATA, appContextValues } from '../constants'
import { TAppContext, TAppContextProviderProps, TInvestmentFormValues, TWebsiteFormValues } from '../types'
import { getChartsValues, getTableValues } from './utils'

export const AppContext = createContext<TAppContext>(appContextValues)

export const ContextProvider: FC<TAppContextProviderProps> = ({ children }) => {

	const [currentWebsiteFormData, setcurrentWebsiteFormData] = useState<TWebsiteFormValues>(CURRENT_WEBSITE_FORM_DATA)
	const [newWebsiteFormData, setnewWebsiteFormData] = useState<TWebsiteFormValues>(NEW_WEBSITE_FORM_DATA)
	const [investmentFormData, setinvestmentFormData] = useState<TInvestmentFormValues>(INVESTMENT_FORM_DATA)
	const [monthsForChart, setmonthsForChart] = useState<number>(12)
	const [tableValues, setTableValues] = useState(getTableValues(currentWebsiteFormData, newWebsiteFormData, investmentFormData, monthsForChart))

	const updateCharts = useCallback(() => getChartsValues(tableValues), [tableValues])
	const chartsValues = updateCharts()

	const value = { currentWebsiteFormData, setcurrentWebsiteFormData, newWebsiteFormData, setnewWebsiteFormData, investmentFormData, setinvestmentFormData, monthsForChart, setmonthsForChart, tableValues, setTableValues, chartsValues }

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}
